<template slot-scope="scope">
  <!-- 处理结果弹窗 -->
      <dialogModel
        :title="PopUpTitle"
        :visible="dialogVerify"
        @handleClose="handleCloseVerify"
        @handleOk="handleUnderstandVerify"
      >
        <div class="main-body">
          <div class="main-body-left">
              <!-- 身份认证时显示 姓名 -->
              <p v-if="distinguish == '3'">
                <span style="color: red">*</span>姓名：
              </p>
              <!-- 身份认证时显示 输入身份证号 -->
              <p v-if="distinguish == '3'">
                <span style="color: red">*</span>身份证号：
              </p>
              <!-- 身份认证时显示 上传身份证 -->
              <p class="UploadIdentity" v-if="distinguish == '3'">
                <span style="color: red">*</span>上传身份证：
              </p>
              <!-- 都显示 选择验证方式 -->
              <p class="verify-mode">
                <span style="color: red">*</span>验证方式：
              </p>
              <!-- 都显示 验证码输入 -->
              <p><span style="color: red">*</span>验证码：</p>
              <!-- 开启支付密码 / 修改忘记支付密码时显示 输入密码 -->
              <p v-if="distinguish == '0' || distinguish == '1'">
                <span style="color: red">*</span
                >{{ distinguish == "0" ? "输入密码：" : "输入新密码：" }}
              </p>
              <!-- 开启支付密码 / 修改忘记支付密码时显示 再次输入密码 -->
              <p v-if="distinguish == '0' || distinguish == '1'">
                <span style="color: red">*</span
                >{{ distinguish == "0" ? "确认密码：" : "确认新密码：" }}
              </p>
            </div>
            <!-- ----------------------------------------------------------- -->
            <div class="main-body-right">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <!-- 认证身份时显示 输入姓名 -->
                <div class="verify-content" v-if="distinguish == '3'">
                  <el-form-item prop="username">
                    <el-input
                      v-model="ruleForm.username"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 认证身份时显示 输入身份证号码 -->
                <div class="verify-content" v-if="distinguish == '3'">
                  <el-form-item prop="number">
                    <el-input
                      v-model="ruleForm.number"
                      placeholder="请输入身份证号码"
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 认证身份时显示 上传身份证 -->
                <!-- 认证身份时显示 上传身份证 -->
                <div
                  class="verify-content UploadIdentity"
                  v-if="distinguish == '3'"
                >
                  <!-- 身份证正面 -->
                  <el-form-item prop="imgSrc">
                    <div class="Upload-box" v-loading="loading">
                      <img class="firm-clickable"
                        :src="ruleForm.imgSrc"
                        alt=""
                        v-show="ruleForm.imgSrc != ''"
                        @click="clickFile(1)"
                      />
                      <!-- 1. 统一用v-show，保证DOM始终存在；2. 修正ref为clearFile1（正面用clearFile1，反面用clearFile2，彻底区分） -->
                      <input
                        type="file"
                        ref="clearFile1"
                        @change="onFileChange"
                        id="file"
                        v-show="ruleForm.imgSrc == ''"
                        style="display: none"
                      />
                      <input
                        type="button"
                        value="点击上传身份证正面"
                        class="btn firm-clickable"
                        @click="clickFile(1)"
                        v-show="ruleForm.imgSrc == ''"
                      />
                      <p v-show="ruleForm.imgSrc == ''">
                        请上传.jpg .png文件，大小不得超过10M
                      </p>
                    </div>
                  </el-form-item>

                  <!-- 身份证反面 -->
                  <el-form-item prop="imgSrc1">
                    <div class="Upload-box" v-loading="loading1">
                      <img class="firm-clickable"
                        :src="ruleForm.imgSrc1"
                        alt=""
                        v-show="ruleForm.imgSrc1 != ''"
                        @click="clickFile(2)"
                      />
                      <!-- 1. 把v-if改成v-show，保证DOM始终存在；2. 修正ref为clearFile2，和正面彻底区分 -->
                      <input
                        type="file"
                        ref="clearFile2"
                        @change="onFileChangeThe"
                        id="file1"
                        v-show="ruleForm.imgSrc1 == ''"
                        style="display: none"
                      />
                      <input
                        type="button"
                        value="点击上传身份证反面"
                        class="btn firm-clickable"
                        @click="clickFile(2)"
                        v-show="ruleForm.imgSrc1 == ''"
                      />
                      <p v-show="ruleForm.imgSrc1 == ''">
                        请上传.jpg .png文件，大小不得超过10M
                      </p>
                    </div>
                  </el-form-item>
                </div>
                <!-- 都显示  选择验证方式 -->
                <div class="verify-mode verify-content">
                  <div
                    class="SelectVerify"
                    v-for="(item, index) in SelectVerify"
                    :key="index"
                  >
                    <div
                      :class="
                        item.id == SelectVerifyId
                          ? 'SelectIcon'
                          : 'NotSelectIcon'
                      "
                      @click="handelSelectVerify(item)"
                    ></div>
                    <p>{{ item.name }}</p>
                    <p>{{ item.data }}</p>
                  </div>
                </div>
                <!-- 都显示 获取验证码 -->
                <div class="verify-content">
                  <el-form-item prop="Code">
                    <el-input
                      v-model="ruleForm.Code"
                      placeholder="请输入"
                    ></el-input>
                    <p
                      class="verify"
                      @click="second == 60 ? handelInvoke() : ''"
                    >
                      {{
                        second === totalSecond && sendNum == 0
                          ? "获取验证码"
                          : second === totalSecond && sendNum != 0
                          ? "再次获取验证码"
                          : second + `s`
                      }}
                    </p>
                  </el-form-item>
                </div>
                <!-- 开启支付密码 / 修改忘记支付密码时显示 输入密码 -->
                <div
                  class="verify-content"
                  v-if="distinguish == '0' || distinguish == '1'"
                >
                  <el-form-item prop="input">
                    <el-input
                      v-model="ruleForm.input"
                      :placeholder="
                        distinguish == '0'
                          ? '请输入6位数字支付密码'
                          : '请输入6位数字新密码'
                      "
                      maxlength="6"
                      show-password
                      @input="onPayPasswordInput('input', $event)"
                    ></el-input>
                  </el-form-item>
                </div>
                <!-- 开启支付密码 / 修改忘记支付密码时显示 再次输入密码 -->
                <div
                  class="verify-content"
                  v-if="distinguish == '0' || distinguish == '1'"
                >
                  <el-form-item prop="input1">
                    <el-input
                      v-model="ruleForm.input1"
                      :placeholder="
                        distinguish == '0'
                          ? '请再次输入6位数字支付密码'
                          : '请再次输入6位数字新密码'
                      "
                      maxlength="6"
                      show-password
                      @input="onPayPasswordInput('input1', $event)"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
        </div>
      </dialogModel>
</template>

<script>
// 引入JSEncrypt用于RSA加密
import JSEncrypt from "jsencrypt";
// 引入接口
import {
  postUpdateUserPayPassword, //开通  更改忘记 支付密码
  postSendAuthCode, // 获取邮箱/手机验证码
  getRSAKey, //获取公钥
  postIdentityAudit, // 个人身份认证
  unbindIdentity, //解绑
} from "../../../../../../assets/api/index";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
import { payPasswordRules, sanitizePayPassword } from "@/utils/payPassword";
import { set } from "vue";
// 在弹窗中获取验证码 destroyed中的应写在handleClose/handleUnderstand中才生效
export default {
  props: {
    dialogVerify: {},
    distinguish: {},
    PopUpTitle: {},
    verifyData: {},
  },
  components: {},
  data() {
    return {
      loading: false,
      loading1: false,
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码

      ruleForm: {
        username: "", //姓名
        number: "", // 身份证号
        Code: "", // 验证码
        input: "", // 新密码
        input1: "", // 二次确认新密码

        imgSrc: "",
        imgSrc1: "",
      },
      rules: {
        // 参数3 change触发，为空时使用自定义提示语    blur
        // 参数4 自定义提示语 / 没有时用封装的
        // 参数2 封装的规则名 / 自定义规则
        // 参数1 false时不验证为空
        Code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"],
          },
        ],
        input1: payPasswordRules({
          requiredMessage: "请再次输入支付密码",
        }),
        input: payPasswordRules(),
        number: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],
        username: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],

        imgSrc: [
          {
            required: true,
            message: "请上传身份证正面",
            trigger: ["blur", "change"],
          },
        ],
        imgSrc1: [
          {
            required: true,
            message: "请上传身份证反面",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
      SelectVerify: [
        { name: "手机验证", data: "", id: "0" },
        { name: "邮箱验证", data: "", id: "1" },
      ], // 可选的验证方法
      SelectVerifyId: "0", //选中的验证方法
      TXurl: "", //身份正面上传到腾讯云的地址
      TXurl1: "", //身份反面上传到腾讯云的地址
    };
  },
  watch: {
    // 监听
    dialogVerify: {
      handler(newSs, old) {
        if (newSs == true) {
          console.log(this.verifyData , 'this.verifyDat')
          this.SelectVerify[0].data = this.$store.getters.getUser.phone;
          this.SelectVerify[1].data = this.$store.getters.getUser.mail;
          if (this.distinguish == "3" && this.verifyData.status == "2") {
            console.log(this.verifyData , 'this.verifyDat')
            this.ruleForm.username = this.verifyData.username;
            this.ruleForm.number = this.verifyData.idNumberPlain;
            this.ruleForm.imgSrc = this.verifyData.idCardImg1;
            this.ruleForm.imgSrc1 = this.verifyData.idCardImg2;
          }
        } else if (newSs == false) {
          clearInterval(this.timer);
          this.timer = null; // 重置定时器 id
          this.second = this.totalSecond; // 归位
          this.ruleForm = {
            username: "", //姓名
            number: "", // 身份证号
            Code: "", // 验证码
            input: "", // 新密码
            input1: "", // 二次确认新密码
            imgSrc: "",
            imgSrc1: "",
          };
          this.SelectVerifyId = "0"; //选中的验证方法
          this.sendNum = "0";

          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    // 给SelectVerify列表赋值 手机号 邮箱
    this.SelectVerify[0].data = this.$store.getters.getUser.phone;
    this.SelectVerify[1].data = this.$store.getters.getUser.mail;
    // 获取公钥
    this.getRSAKey();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  methods: {
    onPayPasswordInput(field, value) {
      this.ruleForm[field] = sanitizePayPassword(value);
    },
    // 点击上传身份证（增加空值判断，双重保险）
    clickFile(num) {
      if (num == 1) {
        const input = document.querySelector("#file");
        // 空值判断：元素存在才执行click
        if (input) input.click();
      } else {
        const input = document.querySelector("#file1");
        if (input) input.click();
      }
    },

    // 正面上传
    async onFileChange(event, opt, callback) {
      this.loading = true;
      // 增加空值判断，避免event.target为undefined
      if (!event?.target) {
        this.loading = false;
        return;
      }
      // 获取上传内容
      var file = event.target.files[0] || event.dataTransfer?.files?.[0];
      // 没有上传内容 加载状态关闭
      if (!file) {
        this.loading = false;
        return;
      }
      // 获取上传内容 名字
      var fileSuffix1 = file.name;
      // 截取 获取  .后缀
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1];
      // 根据后缀判断上传文件是否符合要求
      if (fileSuffix == "jpg" || fileSuffix == "png") {
        //调用封装的上传接口上传文件到cos
        var arr = await this.$tool.onFileChangeNew(event, opt, callback);
        //上传成功  关闭加载状态开始赋值
        if (arr.code == 0) {
          this.loading = false;
          this.TXurl = arr.TXurl;
          this.ruleForm.imgSrc = arr.TXurl;
          this.$refs.ruleForm.validateField("imgSrc");
        } else {
          this.loading = false;
        }
        // 修正ref：用clearFile1，对应正面input
        if (this.$refs.clearFile1) {
          this.$refs.clearFile1.value = "";
        }
      } else {
        // 文件格式错误提示
        this.loading = false;
        this.$tool.PromptBox("error", "请上传jpg/png文件");
      }
    },

    // 反面上传
    async onFileChangeThe(event, opt, callback) {
      this.loading1 = true;
      // 增加空值判断
      if (!event?.target) {
        this.loading1 = false;
        return;
      }
      // 获取上传内容
      var file = event.target.files[0] || event.dataTransfer?.files?.[0];
      if (!file) {
        this.loading1 = false;
        return;
      }
      // 截取 获取  .后缀
      var fileSuffix1 = file.name;
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1];
      // 根据后缀判断上传文件是否符合要求
      if (fileSuffix == "jpg" || fileSuffix == "png") {
        //调用封装的上传接口上传文件到cos
        var arr = await this.$tool.onFileChangeNew(event, opt, callback);
        //上传成功  关闭加载状态开始赋值
        if (arr.code == 0) {
          this.loading1 = false;
          this.TXurl1 = arr.TXurl;
          this.ruleForm.imgSrc1 = arr.TXurl;
          this.$refs.ruleForm.validateField("imgSrc1");
        } else {
          this.loading1 = false;
        }
        // 修正ref：用clearFile2，对应反面input
        if (this.$refs.clearFile2) {
          this.$refs.clearFile2.value = "";
        }
      } else {
        // 文件格式错误提示
        this.loading1 = false;
        this.$tool.PromptBox("error", "请上传jpg/png文件");
      }
    },
    // 获取公钥
    async getRSAKey() {
      const res = await getRSAKey();
      localStorage.setItem("RSA", res.data);
    },

    //切换验证方式
    handelSelectVerify(item) {
      this.SelectVerifyId = item.id;
    },
    // ---------------------------- 点击发送验证码 接口 -----------------------
    handelInvoke() {
      // 获取验证码接口
      var data = {};
      data.data = {
        mail: this.$store.getters.getUser.mail,
        mobile: this.$store.getters.getUser.phone,
        type: this.SelectVerifyId,
        authCodeBusiness:
          this.distinguish == "0" || this.distinguish == "1" ? "5" : "4",
      };
      postSendAuthCode(data).then((res) => {
        if (res.code == 0) {
          this.Countdown();
          this.$tool.PromptBox("success", "验证码已发送");
        } else {
          // 验证码发送失败
          // this.$tool.PromptBox("error", "验证码发送失败");
        }
      });
    },
    // 发送验证码
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },

    // 取消 关闭弹窗
    handleCloseVerify() {
      this.$emit("handleCloseVerify", this.distinguish);
    },

    // 确认
    handleUnderstandVerify() {
      // 使用 RSA 加密两次输入的密码
      const JSE = new JSEncrypt();
      JSE.setPublicKey(localStorage.getItem("RSA"));
      var str = JSE.encrypt(this.ruleForm.input);
      var str1 = JSE.encrypt(this.ruleForm.input1);

      // 表单验证完成 进行下一步
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.distinguish == "0" || this.distinguish == "1") {
            // 开通/更换支付密码
            var data = {};
            // 接口所需参数
            data.data = {
              //userid
              userId: this.$store.getters.getUser.id,
              //认证方式0手机1邮箱
              authType: this.SelectVerifyId,
              // 手机号/邮箱
              mailOrPhone:
                this.SelectVerifyId == "0"
                  ? this.$store.getters.getUser.phone
                  : this.$store.getters.getUser.mail,
              // 验证码
              authCode: this.ruleForm.Code,
              // 更新类型 0开通  1更换
              updateType: this.distinguish,
              //公钥
              publicKey: localStorage.getItem("RSA"),
              // 支付密码1
              payPassword1: str,
              // 确认密码
              payPassword2: str1,
            };
            // 修改密码  开通密码
            postUpdateUserPayPassword(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.$emit("handleUnderstandVerify", this.distinguish);
              }
            });
          } else if (this.distinguish == "3") {
            // 认证身份
            var data = {
              data: {
                userId: this.$store.getters.getUser.id, //userid
                userCode: this.$store.getters.getUser.code, // 用户code
                userName: this.ruleForm.username, // 用户姓名
                idNumber: this.ruleForm.number, // 用户身份证号
                img1: this.ruleForm.imgSrc, // 身份证正面
                img2: this.ruleForm.imgSrc1, // 身份证反面
                authType: this.SelectVerifyId, // 验证方式0手机1邮箱
                mailOrPhone:
                  this.SelectVerifyId == "0"
                    ? this.$store.getters.getUser.phone
                    : this.$store.getters.getUser.mail, // 手机号/邮箱
                authCode: this.ruleForm.Code, // 验证码
              },
            };
            postIdentityAudit(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.$emit("handleUnderstandVerify", this.distinguish);
              }
            });
          } else if (this.distinguish == "4") {
            // 解绑
            var data = {
              data: {
                userId: this.$store.getters.getUser.id,
                authType: this.SelectVerifyId, //验证方式
                mailOrPhone: this.SelectVerify[this.SelectVerifyId].data,
                authCode: this.ruleForm.Code,
              },
            };
            unbindIdentity(data).then((res) => {
              this.$emit("handleUnderstandVerify", this.distinguish);
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-form-item.is-error .Upload-box {
  border-color: #fe574a !important;
}
/deep/.el-form-item {
  margin-bottom: 0px;
  // height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  border: 1px solid #409eff ;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}

.main-body {
  display: flex;
  .main-body-left {
    min-width: 80px;
    text-align: right;
    .UploadIdentity {
      height: 100px;
    }
    p {
      height: 35px;
      line-height: 35px;
      margin-bottom: 30px;
    }
  }
  .main-body-right {
      width: 350px;
      .verify-content:nth-child(1) {
        margin-top: 0px;
      }
      .verify-content {
        height: 35px;
        line-height: 35px;
        margin-top: 30px;
        position: relative;

        // 选择验证方法
        .SelectVerify {
          width: 100%;
          height: 35px;
          line-height: 35px;
          display: flex;
          p {
            margin-right: 20px;
            margin-left: 10px;
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          .NotSelectIcon {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background-image: url("../../../../../../assets/imgs/weigouxuan@3x.svg");
            background-size: 100% 100%;
            margin: auto 0;
          }
          .SelectIcon {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background-image: url("../../../../../../assets/imgs/gouxuan@3x.svg");
            background-size: 100% 100%;
            margin: auto 0;
          }
        }
      }
      .verify {
        position: absolute;
        right: 15px;
        top: 0;
        color: #409eff ;
        cursor: pointer;
      }
      .verify-mode {
        height: 70px;
      }
      .UploadIdentity {
        width: 540px;
        height: 100px;
        display: flex;
        .Upload-box {
          width: 250px;
          height: 100px;
          border: 1px dashed #409eff ;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
          #file {
            display: none;
          }
          #file1 {
            display: none;
          }
          input {
            border: none;
            box-shadow: none;
            outline: none;
            background-color: transparent;
            width: 100%;
            text-align: center;
            color: #409eff ;
            margin-top: 40px;
          }
          p {
            width: 100%;
            text-align: center;
            font-size: 10px;
          }
        }
      }
    }
  }
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
